@if (!isHidden) {
    @let tooltip = slot() | slotTooltip; @let title = slot().titleKey | translationKey: slot().titleData;

    <div class="flex items-start gap-2">
        <div class="flex flex-col">
            <ca-numeric-stepper
                [control]="control"
                [numericMin]="numericMin!"
                [numericMax]="numericMax!"
                [numericStep]="numericStep!"
                [numericMask]="mask"
                [title]="title | requiredMarker: !slot().isOptional"
                [disabled]="!!isDisabled"
                (valueChange)="onValueChange($event)"
            >
                @if (isErrorMessage) {
                    <ca-form-error-message stepper-error>
                        {{ errorMessageTranslation!.key | translationKey: errorMessageTranslation!.data }}
                    </ca-form-error-message>
                }
            </ca-numeric-stepper>
        </div>
        @if (isVisual && !tooltip) {
            <div class="flex items-center ms-2 py-9">
                <ca-visual [slot]="slot()" [iconSize]="24"></ca-visual>
            </div>
        } @else if (tooltip) {
            <div class="flex items-center ms-2 py-9">
                <ca-visual [tooltip]="tooltip"></ca-visual>
            </div>
        }
    </div>
}
